import axios from 'helpers/api';
import DemoFileUpload from 'components/orderdetail/DemoFileUpload';
import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Form, InputGroup, Modal, Row, Button, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const AddOrderModal = ({ show, setShow }) => {
  const [drugOptions, setDrugOptions] = useState([]);
  const [deliveryDates, setDeliveryDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedDrugs, setSelectedDrugs] = useState([]);
  const [newDrug, setNewDrug] = useState("");
  const [note, setNote] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [editableQuantities, setEditableQuantities] = useState({});
  const [docFlag, setDocFlag] = useState(false);
  const [orderTypeValue, setOrderTypeValue] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  let orderTypeVal = JSON.parse(localStorage.getItem("order_types"));
  const orderType = [
    { value: "", label: "Select Order Type" },
    ...Object.keys(orderTypeVal)
      .filter(key => orderTypeVal[key] !== "Refill" && orderTypeVal[key] !== "Task")
      .map((key) => ({
        value: parseInt(key, 10),
        label: orderTypeVal[key]
      }))
  ];

  const location = useLocation();
  const state = location?.state?.data;
  let initalData = {
    patient_id: state?.patientid,
    delivery_date: '',
    order_type: "",
    note: '',
    order_document: {},
    prescriptions: []
  };
  const [formData, setFormData] = useState(initalData);

  useEffect(() => {
    if (show && location.state?.triggeredBy === "someAction") {
      fetchData();
      if (show) {
        const dates = getNextWorkingDays();
        setDeliveryDates(dates);
        if (dates.length > 0) {
          setSelectedDate(dates[0].value);
        }
      }
    }
  }, [show, location?.state]);

  const getNextWorkingDays = () => {
    const workingDays = [];
    let currentDate = new Date();

    const actualTomorrow = new Date();
    actualTomorrow.setDate(actualTomorrow.getDate() + 1);

    currentDate.setDate(currentDate.getDate() + 1);

    while (workingDays.length < 5) {
      const day = currentDate.getDay();
      if (day !== 0 && day !== 6) {
        const isTomorrow =
          currentDate.getDate() === actualTomorrow.getDate() &&
          currentDate.getMonth() === actualTomorrow.getMonth() &&
          currentDate.getFullYear() === actualTomorrow.getFullYear();

        const label = isTomorrow
          ? `Tomorrow (${formatDate(currentDate)})`
          : `${currentDate.toLocaleDateString('en-US', { weekday: 'long' })} (${formatDate(currentDate)})`;

        workingDays.push({
          label,
          value: `${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getDate()).padStart(2, '0')}/${currentDate.getFullYear()}`
        });
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return workingDays;
  };


  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
    });
  };


  const handleQtyChange = (rxNumber, maxQty, value) => {
    const numericValue = parseFloat(value);
    // if (isNaN(numericValue)){
    //   setEditableQuantities((prev) => ({
    //     ...prev,
    //     [rxNumber]: value
    //   }));
    //   if(numericValue < 0.1){
    //     toast.error("Quantity must be greater than 0", { autoClose: 2000 });
    //     setEditableQuantities((prev) => ({
    //       ...prev,
    //       [rxNumber]: ""
    //     }));
    //   }
    // }
    if (numericValue > maxQty) {
      toast.error(`Quantity cannot exceed ${maxQty}`, { autoClose: 2000 });
      setEditableQuantities((prev) => ({
        ...prev,
        [rxNumber]: maxQty.toString()
      }));
      return;
    }
    setEditableQuantities((prev) => ({
      ...prev,
      [rxNumber]: value
    }));
  };  


  async function fetchData() {
    let tokenStr = localStorage.getItem("accessToken");
    setFormData((prev) => ({
      ...prev,
      patient_id: state.patientid + ""
    }));
    const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/orders/list-refill-prescriptions/" + state.patientid, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
    let objData = data.prescriptions
    let results = [];
    objData.map((value) => {
      results.push({
        name: value.drug + ' ' + value.strength_value + ' ' + value.strength,
        rxNumber: value.pharmacy_order_id != null ? value.pharmacy_order_id : 0,
        qty: value.qty ? parseFloat(value.qty) : 0
      })
    })
    setDrugOptions(results)
  }

  const handleDrugSelection = (drug) => {
    if (!selectedDrugs.some((selected) => selected.name === drug.name)) {
      setSelectedDrugs([...selectedDrugs, drug]);
      setDrugOptions(drugOptions.filter((value) => value.rxNumber !== drug.rxNumber));

      setEditableQuantities((prev) => ({
        ...prev,
        [drug.rxNumber]: drug.qty.toString()
      }));
    }
  };

  const handleRemoveDrug = (drug) => {
    setSelectedDrugs(selectedDrugs.filter((selected) => selected.name !== drug.name));
    drugOptions.push(drug)
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setUploadedFile(file);
  };

  const handleFieldChange = (e) => {
    const value = e.target.value;
    setOrderTypeValue(value);
    setDocFlag(value === "3" || value === "4" || value === "5" || value === "6");

    setFormData((prev) => ({
      ...prev,
      order_type: value
    }));
    setErrors((prev) => ({
      ...prev,
      order_type: ""
    }));
  };

  const validateForm = () => {
    let newErrors = {};

    const type = parseInt(orderTypeValue);

    if (!orderTypeValue) {
      newErrors.order_type = "Order Type is required.";
    }

    if (!selectedDate) {
      newErrors.delivery_date = "Delivery Date is required.";
    }

    // For types 2, 3, 5, 6, 7, 8: Drug required
    if ([2, 3, 5, 6, 7, 8].includes(type) && selectedDrugs.length === 0) {
      newErrors.selectedDrugs = "Please select at least one drug.";
    }

    // For type 4: New Drug Name required
    if (type === 4 && !newDrug.trim()) {
      newErrors.newDrug = "Please enter the new drug name.";
    }

  // DOCUMENT REQUIRED FOR ORDER TYPES 5 AND 6 (NEW LOGIC)
  if ([5, 6].includes(type)) {
    const hasDocument = uploadedFile && uploadedFile.length > 0;

    if (!hasDocument) {
      newErrors.uploadedFile = "Document is required for this order type.";
    }
  } else {
    // OLD LOGIC for all other types: note or document must be present
    const hasNote = note.trim() !== "";
    const hasDocument = uploadedFile && uploadedFile.length > 0;
    if (!hasNote && !hasDocument) {
      newErrors.note = "Please enter a note or upload a document.";
      newErrors.uploadedFile = "Please upload a document or enter a note.";
    }
  }

  // Validate quantity > 0 for selected drugs
  if (
    selectedDrugs.length > 0 &&
    selectedDrugs.some(
      (drug) =>
        editableQuantities[drug.rxNumber] &&
        parseFloat(editableQuantities[drug.rxNumber]) <= 0
    )
  ) {
    newErrors.selectedDrugs = "Quantity must be greater than 0 for selected drugs.";
  }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  async function handleSubmit(e) {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    const type = parseInt(orderTypeValue);
    const payload = {
      patient_id: formData.patient_id,
      delivery_date: selectedDate,
      order_type: orderTypeValue,
      note: note,
      order_status: formData.orderstatus,
    };

    if (type !== 4 && selectedDrugs.length > 0) {
      const prescriptions = selectedDrugs.map((drug) => ({
        rx_number: drug.rxNumber,
        quantity: editableQuantities[drug.rxNumber] || drug.qty,
      }));
      payload.prescriptions = JSON.stringify(prescriptions);
    }

    if (type === 4) {
      payload.new_drug = newDrug;
    }

    const submissionData = new FormData();
    Object.keys(payload).forEach((key) => {
      submissionData.append(key, payload[key]);
    });

    if (uploadedFile && uploadedFile.length > 0) {
      uploadedFile.forEach((file) => {
        submissionData.append("documents", file, file.name);
      });
    }

    try {
      const tokenStr = localStorage.getItem("accessToken");
      const pelmedsPrescriptionUrl = `${process.env.REACT_APP_SERVER_URL}/orders/create-prescription-order/`;

      const { data } = await axios.post(pelmedsPrescriptionUrl, submissionData, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (data.status) {
        toast.success("Prescription Order added successfully");
        resetForm();
      } else {
        toast.info("Error occurred while adding/updating Prescription Order.");
        setLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }


  const handleFileChange = (files) => {
    setUploadedFile(files);
  };

  const resetForm = () => {
    setDrugOptions([]);
    setSelectedDrugs([]);
    setNewDrug("");
    setNote("");
    setUploadedFile(null);
    setEditableQuantities({});
    setDocFlag(false);
    setFormData(initalData);
    setShow(false);
    setOrderTypeValue('')
    setLoading(false);
  };
  return (
    <Modal onHide={resetForm} show={show} size="lg">
      <Modal.Header closeButton>
        <Modal.Title as="h5">ADD Order for {state?.individual}/{state?.facilityname}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-body-tertiary p-4">
        <Form onSubmit={handleSubmit}>
          <Row className='mb-3'>
            <Col xs={6}>
              <Form.Label className="required">Delivery On</Form.Label>
              <Form.Select name="selectdeliverydate" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}>
                {deliveryDates.map((date, index) => (
                  <option key={index} value={date.value}>{date.label}</option>
                ))}
              </Form.Select>
              {errors.delivery_date && <small className="text-danger">{errors.delivery_date}</small>}
            </Col>
            <Col>
              <Form.Label className="required">Order Type</Form.Label>
              <Form.Select name="ordertype" value={orderTypeValue} onChange={handleFieldChange}>
                {orderType.map((type) => (
                  <option key={type.value} value={type.value}>{type.label}</option>
                ))}
              </Form.Select>
              {errors.order_type && <small className="text-danger">{errors.order_type}</small>}
            </Col>
          </Row>
          {[2, 3, 5, 6, 7, 8].includes(parseInt(orderTypeValue)) && (
            <>
              <Row className="mt-3">
                <Col>
                  <Dropdown>
                    <Dropdown.Toggle variant="outline-secondary" className='w-50'>Select drug to order</Dropdown.Toggle>
                    <Dropdown.Menu className='w-50' style={{ maxHeight: "200px", overflowY: "auto" }}>
                      {drugOptions.map((drug, index) => (
                        <Dropdown.Item key={index} onClick={() => handleDrugSelection(drug)}>{drug.name}</Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  
                </Col>
              </Row>
              {selectedDrugs.length > 0 && (
                <>
                  <Row className="mt-4">
                    <Col xs={5} sm={6} md={6}>
                      <Form.Label>Drug Name</Form.Label>
                    </Col>
                    <Col xs={3} sm={2} md={2}>
                      <Form.Label>Rx Number</Form.Label>
                    </Col>
                    <Col xs={3} sm={3} md={3}>
                      <Form.Label>Qty</Form.Label>
                    </Col>
                    <Col>
                      {/* <Form.Label>Remove</Form.Label> */}
                    </Col>
                  </Row>

                  {selectedDrugs.map((drug, index) => (
                    <Row key={index} className="mb-3 align-items-center">
                      <Col xs={5} sm={6} md={6}>
                        <Form.Control type="text" value={drug.name} readOnly />
                      </Col>
                      <Col xs={3} sm={2} md={2}>
                        <Form.Control type="text" value={drug.rxNumber} readOnly />
                      </Col>
                      <Col xs={3} sm={3} md={3}>
                        <Form.Control
                          inputMode="decimal"
                          pattern="[0-9]*\.?[0-9]*"
                          value={editableQuantities[drug.rxNumber] ?? drug.qty}
                          placeholder="Enter Qty"
                          onChange={(e) =>
                            handleQtyChange(drug.rxNumber, drug.qty, e.target.value)
                          }
                        />
                      </Col>
                      <Col className="mt-1">
                        <Col
                          className="cursor-pointer"
                          onClick={() => handleRemoveDrug(drug)}
                        >
                          x
                        </Col>
                      </Col>
                    </Row>
                  ))}
                  {errors.selectedDrugs && <small className="text-danger">{errors.selectedDrugs}</small>}
                </>
              )}
            </>
          )}
          {parseInt(orderTypeValue) === 4 && (
            <Row className="mb-3">
              <Col>
                <Form.Label className="required">New Drug Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter new drug name"
                  value={newDrug}
                  onChange={(e) => setNewDrug(e.target.value)}
                />
                {errors.newDrug && <small className="text-danger">{errors.newDrug}</small>}
              </Col>
            </Row>
          )}

          {[2, 3, 4, 5, 6, 7, 8].includes(parseInt(orderTypeValue)) && (
            <Row>
              <Col>
                <Form.Label className={[5, 6].includes(parseInt(orderTypeValue)) ? "required" : ""}>
                  Upload Document
                  {!([5, 6].includes(parseInt(orderTypeValue))) && (
                    <span className="text-muted">(Optional if note provided)</span>
                  )}
                </Form.Label>
                <DemoFileUpload
                  onFilesChange={handleFileChange}
                  textOfDoc={'Document Upload'}
                  errorFlag={!!errors.uploadedFile}
                />
                {errors.uploadedFile && <small className="text-danger">{errors.uploadedFile}</small>}
              </Col>
            </Row>
          )}
          {orderTypeValue && (
            <Row>
              <Col>
                <Form.Label>Notes <span className="text-muted">(Optional if document uploaded)</span></Form.Label>
                <Form.Control as="textarea" rows={1} value={note} onChange={(e) => setNote(e.target.value)} />
                {errors.note && <small className="text-danger">{errors.note}</small>}
              </Col>
            </Row>
          )}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Label className="text-danger text-center fw-bold">
                *Please call pharmacy for urgent or after hours deliveries.
              </Form.Label>
            </Col>
          </Row>
          <Row className='d-flex justify-content-center'>
            <Button type="submit"
              color="primary"
              name="addordermodalsubmit"
              className='w-25'
              disabled={loading}>
              {loading ? <Spinner size="sm" animation="border" /> : "Submit"}
            </Button>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddOrderModal;

